(function () {
    'use strict';

    angular
        .module('portal-common')
        .directive('coverNavitem', navitem);

    function navitem() {
        return {
            restrict: 'E',
            scope: {
                item: '='
            },
            controller: navitemCtrl,
            controllerAs: 'vm',
            bindToController: true,
            template: '<a ng-if="vm.item.link" ng-bind-html="vm.item.label" ng-if="vm.item.link" ng-click="vm.clickHref(vm.item.link)" target="<% vm.item.target || \'_self\'%>"></a>'
        };
    }

    function navitemCtrl($location, $document) {
        var vm = this;
        this.$onInit = function() {
            vm.clickHref = clickHref;
        }

        function clickHref(href) {
            if (href.indexOf('//') >= 0) {
                openExternal(href, vm.item.target);
            } else {
                $location.path(href);
            }
            $document.focus();
        }

        function openExternal(link, target) {
            window.open(link, target);
        }
    }
})();
